import styled from 'styled-components';

export const MainWrapper = styled.div`
	flex-grow: 1;
`;
